/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Onl_Teaser_TitleInputs */

const en_vc_onl_teaser_title = /** @type {(inputs: Vc_Onl_Teaser_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Use VectorCraft online, right in your browser`)
};

const zh_vc_onl_teaser_title = /** @type {(inputs: Vc_Onl_Teaser_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在浏览器里直接使用 VectorCraft`)
};

/**
* | output |
* | --- |
* | "Use VectorCraft online, right in your browser" |
*
* @param {Vc_Onl_Teaser_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_onl_teaser_title = /** @type {((inputs?: Vc_Onl_Teaser_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Onl_Teaser_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_onl_teaser_title(inputs)
	return zh_vc_onl_teaser_title(inputs)
});
export { vc_onl_teaser_title as "vc.onl.teaser.title" }